import { render, staticRenderFns } from "./OtherService.vue?vue&type=template&id=15859745&scoped=true"
import script from "./OtherService.vue?vue&type=script&lang=js"
export * from "./OtherService.vue?vue&type=script&lang=js"
import style0 from "./OtherService.vue?vue&type=style&index=0&id=15859745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15859745",
  null
  
)

export default component.exports